import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { fetchToolSettings } from "../services/ToolSettingsServices"; 

interface ToolSettings {
  [toolID: number]: boolean; // Stores toolID as key and visibility (status === 1) as value
}

interface ToolSettingsContextType {
  toolSettings: ToolSettings;
}

const ToolSettingsContext = createContext<ToolSettingsContextType | undefined>(undefined);

export const ToolSettingsProvider = ({ children }: { children: ReactNode }) => {
  const { authState } = useOktaAuth();
  const [toolSettings, setToolSettings] = useState<ToolSettings>({});
  const oktaAccessToken = authState?.accessToken?.accessToken;

  useEffect(() => {
    if (!oktaAccessToken) return;

    const getToolSettings = async () => {
      const data = await fetchToolSettings(oktaAccessToken);
      
      // Convert response into an object where toolID is key and status is value
      const settingsMap: ToolSettings = {};
      data.forEach((tool: { toolID: number; status: number }) => {
        settingsMap[tool.toolID] = tool.status === 1;
      });
      // console.log("context", settingsMap);

      setToolSettings(settingsMap);
    };

    getToolSettings();
  }, [oktaAccessToken]);
  return (
    <ToolSettingsContext.Provider value={{ toolSettings }}>
      {children}
    </ToolSettingsContext.Provider>
  );
};

export const useToolSettings = () => {
  const context = useContext(ToolSettingsContext);
  if (!context) {
    throw new Error("useToolSettings must be used within a ToolSettingsProvider");
  }
  return context;
};
